import { getConfiguration } from "./configuration";

export function isUKCombinationMaskEnabled() {
	const conf = getConfiguration();
	return conf.ukce;
}
